module.exports = __webpack_public_path__ + "static/media/icon_twitter.1ef7554e.svg";